module.exports = __webpack_public_path__ + "assets/spec_phone_background.6e2b44f4bc6773e079906ce43b220697a57c39f3bf72774e2e69c85b95371c25.jpg";